import { createSelector } from '@ngrx/store';
import { SelectSupplierModuleState } from '../suppliermodule.selector';
import { SupplierPropertyValue, SupplierDocumentPropertyValues } from 'app/profile/models/supplier.model';
import { isNullOrEmpty } from 'app/shared/utils/utils';


export const SelectSupplierState = createSelector(SelectSupplierModuleState, state => state.SupplierState);

export const SelectCurrentUser = createSelector(SelectSupplierState, state => state && state.currentUser);

export const SelectSupplierAddressList = createSelector(SelectSupplierState, state => state.supplier.addresses);

export const SelectNavigationList = createSelector(SelectSupplierState, state => state.navigationList);

export const SelectSupplierContactList = createSelector(SelectSupplierState, state => state.supplier.contacts);
export const SelectSupplierDiversity = createSelector(SelectSupplierState, state => state.supplier.diversity);
export const SelectEmailDomainList = createSelector(SelectSupplierState, state => state.supplier.domains);

export const SelectSupplierEhsResponse = createSelector(SelectSupplierState, state => state.supplier.ehsResponse);

export const SelectTabPermissions = createSelector(SelectSupplierState, state => state.tabPermission);

export const SelectSupplierEntityList = createSelector(SelectSupplierState, state => state.supplier.entities);

export const SelectSupplierProfile = createSelector(SelectSupplierState, state => state.supplierProfile);
export const SelectSupplierTypes = createSelector(SelectSupplierProfile, state => state.supplierDetails.supplierCategory);

export const SelectAddressModifiedSupplier = createSelector(SelectSupplierState, state => {
    const addressModifiedSupplier = new SupplierPropertyValue();
    if (state.supplier.addresses && state.supplier.addresses.filter(x => x.isTouched).length > 0) {
        addressModifiedSupplier.addresses = state.supplier.addresses.filter(x => x.isTouched);
        if (state.supplier.addresses.filter(x => x.attachments != null)) {
            addressModifiedSupplier.documents = new Array<SupplierDocumentPropertyValues>();
        }
    }
    return isNullOrEmpty(addressModifiedSupplier) ? null : addressModifiedSupplier;
});

export const SelectSupplierChannelList = createSelector(SelectSupplierState, state => {
    return state.supplier.channels;
});

export const SelectSupplierDocumentList = createSelector(SelectSupplierState, state => state.supplier.documents);

export const SelectFieldConfiguration = createSelector(SelectSupplierState, state => state.FieldConfiguration);

export const SelectSupplierWarehouseAddressList = createSelector(SelectSupplierState, state => state.warehouseAddresses);

export const SelectSupplierPickupWarehouseAddressList = createSelector(SelectSupplierState, state => state.pickupWarehouseAddresses);

export const getSupplierExternalPartnerList = createSelector(SelectSupplierState, state => state.externalPartnerAddress);

export const SelectValidationTask = createSelector(SelectSupplierState, state => state && state.validationTask);

export const SelectSupplierContracts = createSelector(SelectSupplierState, state => state && state.contracts);

export const SelectSupplierLocations = createSelector(SelectSupplierState, state => state && state.locations);

export const SelectSupplierBankList = createSelector(SelectSupplierState, state => state.supplier.banks);

export const SelectSupplierTaxList = createSelector(SelectSupplierState, state => state.supplier.taxes);

export const SelectSupplierMfgAddressList = createSelector(SelectSupplierState, state => state.manufacturingAddresses);

export const SelectSupplierOtpRequest = createSelector(SelectSupplierState, state => state && state.otpRequest);

export const SelectUserPendingTaskList = createSelector(SelectSupplierState, state => state && state.userPendingTasks);

export const SelectPreventativeInProgress = createSelector(SelectSupplierState, state => state && state.preventativeInProgress);